/** Ошибки, которые различаются по смыслу, а не только по коду. */

/** 401: сессии нет или она протухла. Лечится повторным входом. */
export class UnauthorizedError extends Error {
  constructor() {
    super("не авторизован");
    this.name = "UnauthorizedError";
  }
}

/**
 * 403: вошёл, но группы нет. Повторным входом НЕ лечится — и именно поэтому
 * отделён от 401. Свалить их в один отказ значит отправить человека по кругу
 * входов, каждый из которых заканчивается тем же самым.
 */
export class ForbiddenError extends Error {
  constructor() {
    super("доступ запрещён");
    this.name = "ForbiddenError";
  }
}

/**
 * GET с разбором JSON.
 *
 * `cache: "no-store"` обязателен: состояние сессии и списки камер посредники
 * кэшируют охотно, а устаревший ответ здесь выглядит не ошибкой, а тем, что
 * «ничего не происходит».
 *
 * `credentials` не задаём: умолчание `same-origin` — ровно то, что нужно, а
 * явный `include` пришлось бы сопровождать настройкой CORS, которой у нас нет
 * и не должно быть.
 */
export async function getJson<T>(path: string): Promise<T> {
  const res = await fetch(path, { cache: "no-store" });
  if (res.status === 401) throw new UnauthorizedError();
  if (res.status === 403) throw new ForbiddenError();
  if (!res.ok) throw new Error(`${path}: HTTP ${res.status}`);
  return (await res.json()) as T;
}
